import { Alert, LinearProgress } from "@mui/material";
import type { FC } from "react";
import { useAccount } from "../../../modules/generic/hooks/use-account";
import { NO_TRACKING_SES_CONFIGURATION_SET } from "../../../modules/generic/server/supabase-account-service";
import { Page } from "../../../modules/layout/components/page";
import { PageContent } from "../../../modules/layout/components/page-content";
import { PageHeader } from "../../../modules/layout/components/page-header";
import { PageHeading } from "../../../modules/layout/components/page-heading";
import { useUsedMomentsInfo } from "../../../modules/moment/hooks/use-moment";
import { useUsedProgramsInfo } from "../../../modules/moment/hooks/use-programs";
import { useUsedSegmentInfo } from "../../../modules/segment/server/use-segments";
import { AnalyticsSentMomentsTable } from "./components/analytics-sent-moments-table";

const SentMomentsPage: FC = () => {
  const segmentInfo = useUsedSegmentInfo();
  const programInfo = useUsedProgramsInfo();
  const momentInfo = useUsedMomentsInfo();
  const accountInfo = useAccount();

  return (
    <Page title="Sent Communications | ChangeEngine">
      <PageHeader>
        <PageHeading heading="Sent Communications" />
      </PageHeader>
      <PageContent>
        {(segmentInfo.loading ||
          programInfo.loading ||
          momentInfo.loading ||
          accountInfo.loading) && <LinearProgress />}
        {(segmentInfo.error || programInfo.error || momentInfo.error || accountInfo.error) && (
          <Alert severity="error">Unable to load data</Alert>
        )}
        {accountInfo.data?.ses_configuration_set === NO_TRACKING_SES_CONFIGURATION_SET && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Your company has opted not to include tracking images in email communications. As a
            result, open rate metrics will be inaccurate or unavailable.
          </Alert>
        )}
        <AnalyticsSentMomentsTable
          segments={segmentInfo.data ?? []}
          programs={programInfo.data ?? []}
          moments={momentInfo.data ?? []}
        />
      </PageContent>
    </Page>
  );
};

export default SentMomentsPage;
